import { render } from "./DependentDelete.vue?vue&type=template&id=36185b43&scoped=true&ts=true"
import script from "./DependentDelete.vue?vue&type=script&lang=ts"
export * from "./DependentDelete.vue?vue&type=script&lang=ts"

import "./DependentDelete.vue?vue&type=style&index=0&id=36185b43&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36185b43"]])

export default __exports__